module.exports = __webpack_public_path__ + "img/newsImg2-3.13a118a1.png";